import { render, staticRenderFns } from "./MensajesReclamacion.vue?vue&type=template&id=12486380&scoped=true&"
import script from "./MensajesReclamacion.vue?vue&type=script&lang=js&"
export * from "./MensajesReclamacion.vue?vue&type=script&lang=js&"
import style0 from "./MensajesReclamacion.vue?vue&type=style&index=0&id=12486380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12486380",
  null
  
)

export default component.exports